import React, { useState } from 'react';
import './Navbar.css';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import mindspaceLogo from '../Assets/LogoB1.jpg';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const scrollToSection = (sectionId) => {
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsOpen(false);
  };

  return (
    <div className="navbar">
      <div className="logo">
        <img
          className="mindspacelogo"
          src={mindspaceLogo}
          alt="TMS Mindspace Logo"
        />
        <Link to="/" ><h1 className='mindspacename'>MINDSPACE</h1></Link>
        <div className="toggle_btn" onClick={toggleMenu}>
          <FontAwesomeIcon icon={isOpen ? faTimes : faBars} />
        </div>
      </div>

      {/* Added isOpen class here */}
      <div className={`navbar-content ${isOpen ? "open" : ""}`}>
        <ul className="links">
          <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('howItWorks'); }}>How It Works</a></li>
          <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>About Us</a></li>
          <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Services</a></li>
          <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('newPatients'); }}>New Patients</a></li>
          <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact Us</a></li>
        </ul>

        <div className="contact-info">
          <div className="contact-header">
            <span className="contact-label">Reach out to us</span>
          </div>
          <div className="contact-item">
            <a href="tel:(325)603-4513" className="contact-link">(325) 603-4513</a>
          </div>
          <div className="contact-item">
            <a href="mailto:mindspace@mindspacellc.com" className="contact-link">mindspace@mindspacellc.com</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;